<template>
  <div>
    <div class="deposit-title">
      <global-title :title="$t('deposit.default.deposit')"></global-title>
    </div>
    <div
      id="depositPCS"
      v-resizeObserver="{
        openResize: true,
        handler: observerCallBack
      }"
    >
      <div :style="cssVars">
        <div class="step1" v-show="showAccountBlock">
          <ChooseAccount
            @submit="submitStep1"
            :amount.sync="amount"
            :accountNumber.sync="accountNumber"
            :currency.sync="currency"
            :redemptionCode.sync="redemptionCode"
            :voucherApplied.sync="voucherApplied"
            :showSteps.sync="showSteps"
            :accountType.sync="accountType"
            :accountPlatform.sync="accountPlatform"
            :userCouponId.sync="userCouponId"
            :capAmount.sync="capAmount"
            :amountErrMsg.sync="amountErrMsg"
            :couponType.sync="couponType"
          />
          <DepositBonusDialog
            :depositDialogVisible.sync="dialogDepositBonusVisible"
            :campaignName="campaign ? campaign.name : null"
            @optInClick="optInDepositBonus"
            @notShowAgain="doNotShowDialog"
          ></DepositBonusDialog>
          <!-- <CarouselBanner /> -->
        </div>
        <div class="step2" v-show="showIframe">
          <iframe id="pcs-iframe" width="100%" allow="clipboard-read; clipboard-write"></iframe>
        </div>
        <div v-if="showCpsPayIframe" v-html="cpsPayHTML"></div>
        <div class="nonCPSOfflineDepositResult" v-if="showResult">
          <NonCPSOfflineDepositResult
            :resultChannelType="resultChannelType"
            :orderNumber="orderNumber"
            :hasFileList="fileList.length > 0"
          />
        </div>
      </div>
      <vUploadNewImage
        v-show="false"
        ref="uploadRef"
        :limit="getMaxFileNumber"
        :maxSize="getMaxFileSize"
        :allowed-file="getAllowUploadFileTypes"
        @updateFileInfo="updateFileInfo"
        :accept="getAcceptFile"
        :action="uploadAction"
        :isCustomerRemove="true"
      />
      <FileViewer v-if="showFileViewer" :file="showedFile" :showFileViewer.sync="showFileViewer" />
      <PCSDialog
        :dialogVisible.sync="showPCSDialog"
        :dialogType="showPCSDialogType"
        :limit="channelLimit"
        :custom-btn-click="customPCSDialogBtnClick"
        :choose-another-payment="customPCSDialogAnotherPaymentClick"
      />
      <PcsPopup :dialogVisible.sync="showTncPopup" :popupData="tncPopupData" :sensorsClick="sensorsClick" />
      <AppleSolidPayDialog
        v-if="showAppleSolidPay"
        :visible.sync="showAppleSolidPay"
        :appleSolidPayData="appleSolidPayData"
        :accountNum="accountNumber"
        :amount="amount"
        :accountCurrency="currency"
      />

      <!-- <DepositRestriction :dialogVisible.sync="depositRVisible" :depositType="depositType"></DepositRestriction> -->

      <!-- <el-dialog
        class="sumsub_websdk_dialog"
        :visible="isShowSumsubDialog"
        :show-close="false"
        @close="isShowSumsubDialog = false"
      > -->
      <!-- display: flex to avoid extra space between iframe and container -->
      <!-- <div id="sumsub-websdk-container" style="display: flex"></div> -->
      <!-- </el-dialog> -->
    </div>
  </div>
</template>

<script>
// import CarouselBanner from '@/components/home/CarouselBanner.vue';
import DepositBonusDialog from '@/components/deposit/DepositBonusDialog.vue';
import ChooseAccount from '@/components/deposit/paymentCenterSystem/ChooseAccount.vue';
import vUploadNewImage from '@/components/vUploadNewImage.vue';
import FileViewer from '@/components/deposit/paymentCenterSystem/FileViewer.vue';
import PCSDialog from '@/components/deposit/paymentCenterSystem/PCSDialog.vue';
import NonCPSOfflineDepositResult from '@/components/deposit/paymentCenterSystem/NonCPSOfflineDepositResult.vue';
// import Banner from '@/components/deposit/paymentCenterSystem/Banner.vue';
import { apiCampaignInfo, apiCampaignOptInPopup, apiCampaignOpt, apiGetSumsubAccessToken } from '@/resource';
import { apiPcsInitDeposit } from '@/resource/pcs';
import mixin from '@/mixins/page/deposit';
import { I18N_PAYMENT_CENTER_MAP } from '@/constants/language';
import {
  NON_CPS_OFFLINE_DEPOSIT_LIST,
  REDIRECT_BY_RESPONSE_MSG_DEPOSIT_LIST
} from '@/constants/payment/nonCPSOfflineDepositList';
import { countryCodeEnum } from '@/constants/country';
import { statusDeposit } from '@/constants/auditStatus';
// import DepositRestriction from '@/components/deposit/DepositRestriction';
// import ibtDepositRestriction from '@/components/deposit/ibtDepositRestriction';
import {
  sensorsDepositStep1PageAccountSelect,
  sensorsDepositStep1PageAmountInput,
  sensorsDepositStep1PageVoucherUse,
  sensorsDepositStep1PageContinueClick
} from '@/util/sensorsdata/util';
import sensorsHandler from '@/util/sensorsdata/handler';
import PcsPopup from '@/components/deposit/paymentCenterSystem/PcsPopup.vue';
import { sumsubStatusEnum } from '@/components/sumsub/SumsubVerificationDialog.vue';
import snsWebSdk from '@sumsub/websdk';
import { I18N_PLATFORM_MAP } from '@/constants/language';
import debounce from 'lodash.debounce';
import { RegisterRoutePath } from '@/router/registerRoutes';

import GlobalTitle from '@/components/global/title';
import store from '@/store/index';
import AppleSolidPayDialog from '@/components/deposit/paymentCenterSystem/AppleSolidPayDialog.vue';

export default {
  components: {
    ChooseAccount,
    vUploadNewImage,
    FileViewer,
    PCSDialog,
    PcsPopup,
    NonCPSOfflineDepositResult,
    DepositBonusDialog,
    // DepositRestriction,
    GlobalTitle,
    AppleSolidPayDialog
  },
  mixins: [mixin],
  data() {
    return {
      activeNames: ['1'], // Old
      dialogDepositBonusVisible: false,
      campaign: null,
      accountNumber: null,
      currency: null,
      amount: 0,
      showSteps: true,
      redemptionCode: null,
      voucherApplied: null,
      showAccountBlock: true,
      showIframe: false,
      iframeHeight: 670,
      showCpsPayIframe: false,
      channelLimit: null,
      cpsPayHTML: '',
      routerFlag: true,
      showPCSDialogType: '',
      showPCSDialog: false,
      uploadAction: '/api/file/upload',
      fileList: [],
      allowUploadFileTypes: null,
      maxFileNumber: 1,
      maxFileSize: 3,
      showFileViewer: false,
      showedFile: null,
      customPCSDialogBtnClick: () => {},
      resultChannelType: null,
      orderNumber: null,
      showResult: false,
      showBridgePay: false,
      currentStep: 1,
      historyBackNum: -1,
      excludeReviewCountries: [countryCodeEnum.SPAIN],
      depositRVisible: false,
      depositType: '',
      ibtdepositRVisible: false,
      accountType: null,
      accountPlatform: null,
      userCouponId: null,
      capAmount: null,
      showTncPopup: false,
      tncPopupData: null,
      amountErrMsg: null,
      couponType: null,
      customPCSDialogAnotherPaymentClick: this.chooseAnotherPayment,
      orderInfo: {},
      // sumsubStatus: sumsubStatusEnum.success,
      isShowSumsubDialog: false,
      sumsubAccessToken: '',
      showAppleSolidPay: false,
      appleSolidPayData: {}
    };
  },
  methods: {
    async getCompaignData() {
      const availableCampaignIds = [6, 7, 17, 5049];
      // 6 = Welcome5020
      // 7 = 	ROW Welcome5010
      // 17 = Welcome2010
      // 5049 = 	APAC Welcome5010
      if (
        this.eligibleCampaigns.length > 0 &&
        this.eligibleCampaigns.some(
          campaign => campaign.campaignType === 'DEPOSIT_BONUS_2' && availableCampaignIds.includes(campaign.id)
        )
      ) {
        this.campaign = this.eligibleCampaigns.find(
          campaign => campaign.campaignType === 'DEPOSIT_BONUS_2' && availableCampaignIds.includes(campaign.id)
        );
        const resp = await apiCampaignInfo(this.campaignDepositBonusID);
        const campaignInfoResp = resp.data;

        if (campaignInfoResp.code === 0) {
          let overBonus = campaignInfoResp.data.reachedMaximumBonus;
          let notInCampaign = !campaignInfoResp.data.in;
          let showOptInPopup = campaignInfoResp.data.showOptInPopup;
          if (!overBonus && notInCampaign && showOptInPopup) {
            //Currently will show opt in notification for 5010, 5020, 2010 campaigns
            this.dialogDepositBonusVisible = true;
          }
        }
      }
    },
    optInDepositBonus() {
      apiCampaignOpt(this.campaign.id, true)
        .then(resp => {
          if (resp.data.data) {
            this.dialogDepositBonusVisible = false;
          } else {
            this.errorMessage(this.$t('loyaltyProgram.common.error'));
          }
        })
        .catch(err => {
          this.errorMessage(this.$t('loyaltyProgram.common.error'));
        });
    },
    doNotShowDialog() {
      // apiCampaignOptInPopup(this.campaign.id, false);
      this.dialogDepositBonusVisible = false;
    },
    async submitStep1(valid) {
      if (valid) {
        try {
          this.loading = true;
          this.showIframe = false;
          const res = await apiPcsInitDeposit(
            {
              mt4Account: this.accountNumber,
              operateAmount: this.amount,
              feBrand: 'vt',
              language: this.pcsLang,
              redemptionCode: this.redemptionCode,
              voucherApplied: this.voucherApplied
            },
            this.token
          );
          this.sensorsClick('DEPOSIT_STEP1PAGE_CONTINUE_CLICK', { error_number: res.data.code });
          if (res.data.code == 0 && res.data.data.length > 0) {
            const iframe = document.getElementById('pcs-iframe');
            iframe.src = res.data.data;
            iframe.onload = () => {
              this.loading = false;
              this.showAccountBlock = false;
              this.showIframe = true;
              if (navigator.userAgent.includes('Firefox')) {
                history.pushState(null, document.title, window.location.href);
              }
            };
            this.currentStep = 2;
          }
        } catch (error) {
          this.loading = false;
          this.showAccountBlock = true;
          this.showIframe = false;
          console.error(error);
          this.errorMessage(this.$t('deposit.default.failed'));
        }
      }
    },
    receiveMessage: debounce(async function (event) {
      const { status } = event?.data;
      let data = event.data.data;
      if (data) {
        if (typeof event.data.data === 'string') {
          data = JSON.parse(event.data.data);
        }
      }
      console.log('data', data);
      switch (status) {
        case 'backToStep1':
          this.goBackStep1();
          sensorsHandler('DEPOSITPAGE_BACK_CLICK', {
            current_page_name: `DepositStep${this.currentStep}`,
            account_type: this.accountType,
            account_info: this.accountNumber
          });
          return;
        case 'pcsSuccess':
          if (this.routerFlag) {
            console.log('event.data.data', data);
            if (data?.targetChannel.owner === 'CPS') {
              this.routerFlag = false;
              this.showIframe = false;
              this.cpsPayHTML = data?.result.payment_content;
              this.showCpsPayIframe = true;
              this.$nextTick(() => {
                setTimeout(() => {
                  let sub = document.getElementById('paysubmit');
                  if (sub !== null) {
                    if (sub) {
                      sub.submit();
                    } else {
                      this.errorMessage(this.$t('deposit.default.failed'));
                      this.goBackStep1();
                    }
                  }
                }, 100);
              });
            } else if (data?.targetChannel.channelName === 'BridgerPay CC') {
              //BridgePay
              this.orderInfo = { ...data.orderInfo };
              this.$store.commit('payment/setOrderInfo', this.orderInfo);
              this.sensorsClick('DEPOSIT_STEP2PAGE_JUMP_THIRD_PARTY');
              this.routerFlag = false;
              if (data.result.data) {
                this.$store.dispatch('payment/actionSetBridgePayData', data.result.data);
                this.$router.push({ name: 'bridgePaymentDepositPCS' });
              }
            } else if (data?.targetChannel.channelName === 'ApplePay-Solid') {
              //TODO:
              if (data.result.data && data.result.code === 0) {
                this.goBackStep1();
                this.appleSolidPayData = { ...data.result.data };
                this.showAppleSolidPay = true;
              } else {
                this.goBackStep1();
                this.errorMessage(this.$t('deposit.default.failed'));
              }
            } else if (data?.targetChannel.channelName === 'EU Bank Transfer') {
              //EU Bank Transfer
              window.location.href = data?.result.data;
            } else if (REDIRECT_BY_RESPONSE_MSG_DEPOSIT_LIST.includes(data.targetChannel.channelName)) {
              if (data.result.data && data.result.code === 0) {
                window.location = data.result.msg;
              } else {
                this.goBackStep1();
                this.errorMessage(this.$t('deposit.default.failed'));
              }
            } else if (NON_CPS_OFFLINE_DEPOSIT_LIST.includes(data?.targetChannel.channelName)) {
              this.resultChannelType = data.targetChannel.endpoint.split('/')[1];
              this.orderNumber = data.result.data.orderNumber;
              this.showIframe = false;
              this.showResult = true;
            } else if (data.targetChannel.channelName === 'Checkout CC') {
              this.orderInfo = { ...data.orderInfo };
              this.$store.commit('payment/setOrderInfo', this.orderInfo);
              this.sensorsClick('DEPOSIT_STEP2PAGE_JUMP_THIRD_PARTY');
              this.$store.dispatch('payment/actionSetCheckoutCCData', {
                publicKey: data.result.api_key,
                source: data.result.checkout_url,
                action: data.result.action_url,
                accountNumber: this.accountNumber,
                amount: this.amount,
                currency: this.currency
              });
              this.showIframe = false;
              this.$router.push({ name: 'checkoutCCPCS' });
            }
          }
          return;
        case 'changeChannel':
          console.log('changeChannel-crmmmmmm');
          this.$refs.uploadRef.clearFileList();
          break;
        case 'invalidateChannel':
          this.orderInfo = { ...data.orderInfo };
          this.handlePCSDialog(data.channel.reason, data?.channel);
          break;
        case 'noDataCheckReason':
          this.handlePCSDialog('unAvailableChannel');
          break;
        case 'uploadFile':
          const { allowedFileTypes, maxFileNumber, maxFileSize, isCpsChannel } = data;
          this.allowUploadFileTypes = allowedFileTypes;
          this.maxFileNumber = maxFileNumber;
          this.maxFileSize = maxFileSize;
          this.uploadAction = isCpsChannel ? '/api/file/cps-upload' : '/api/file/upload';
          setTimeout(() => {
            if (this.$refs.uploadRef) {
              this.$refs.uploadRef.$refs.uploadImgRef.$refs['upload-inner'].$refs.input.click();
            }
          }, 300);

          break;
        case 'previewFile':
          if (data) {
            const file = this.fileList.find(file => file.uid === data.file.uid);
            if (file) {
              this.showedFile = file;
              this.showFileViewer = true;
            }
          }
          break;
        case 'removeFile':
          if (data) {
            this.removeFileList(data);
          }
          break;
        case 'currentStep':
          this.currentStep = parseInt(data);
          break;
        case 'fetchPcsPageHeight':
          console.log('data : ', data);
          // const iframe = document.getElementById('pcs-iframe');
          this.iframeHeight = data;
          // const minHeight = Math.max(parseInt(data) + 100, 670);
          // const minHeight = Math.max(parseInt(data) + 100, 400);
          // iframe.style.height = minHeight + 'px';

          // const minHeight = data;
          // iframe.style.height = minHeight + 'px';
          break;
        case 'linkForOpenNewPage':
          window.open(data);
          break;
        case 'pcsFail':
        case 'fetchChannelListFail':
          this.errorMessage(this.$t('deposit.default.processFailed'));
          this.goBackStep1();
          break;
        case 'voucherRemoveSuccess':
          this.$message({
            message: this.$t('deposit.default.removeVoucherSuccess'),
            type: 'success'
          });
          break;
        case 'voucherRemoveFail':
          this.errorMessage(this.$t('deposit.default.removeVoucherFailed'));
          break;
        case 'changeAmountSuccess':
          this.$message({
            message: this.$t('deposit.default.amountChangeSuccess'),
            type: 'success'
          });
          break;
        case 'changeAmountFail':
          this.errorMessage(this.$t('deposit.default.amountChangeFailed'));
          break;
        case 'tncPopup':
          this.tncPopupData = data;
          this.showTncPopup = true;
          this.orderInfo = { ...event?.data?.orderInfo };
          break;
        case 'rateLimit':
          this.goBackStep1();
          this.errorMessage(this.$t('deposit.default.rateLimit'));
          break;
        case 'timeout':
          this.errorMessage(this.$t('pcsPayment.timeoutMsg'));
          break;
        case 'xssError':
          this.errorMessage(this.$t('pcsPayment.unauthorizedSymbols'));
          break;
        case 'channelSubmitError':
          this.goBackStep1();
          this.errorMessage(this.$t('deposit.default.channelSubmitError'));
          break;
      }
    }, 300),
    async goBackStep1() {
      this.showIframe = false;
      this.showAccountBlock = true;
      this.currentStep = 1;
      this.historyBackNum = this.historyBackNum - 1;
    },
    helpSupport() {
      this.$router.push('/contactUs');
    },
    removeVoucher() {
      const iframe = document.getElementById('pcs-iframe');
      iframe.contentWindow.postMessage(
        {
          status: 'removeVoucher'
        },
        '*'
      );
      this.showPCSDialog = false;
      this.sensorsClick('DEPOSIT_POPUP_COUPONUNUSABLE_CLICK', { button_name: 'Remove Coupon' });
    },
    changeAmount(amount) {
      const iframe = document.getElementById('pcs-iframe');
      iframe.contentWindow.postMessage(
        {
          status: 'changeAmount',
          data: amount
        },
        '*'
      );
      this.showPCSDialog = false;
    },
    completedKYC() {
      this.$router.push(RegisterRoutePath.ibtRegister);
      // this.$store.commit('register/setRegisterPopupShow', true);
      // 入金未完成进阶KYC弹窗点击
      this.sensorsClick('DEPOSIT_POPUP_ADVANCEDKYCREQ_CLICK', { button_name: 'Complete Advance KYC' });
    },
    chooseAnotherPayment() {
      const iframe = document.getElementById('pcs-iframe');
      iframe.contentWindow.postMessage(
        {
          status: 'chooseAnotherPayment'
        },
        '*'
      );
      this.showPCSDialog = false;
    },
    updateFileInfo({ fileList = [], file = '' }) {
      this.fileList = fileList;
    },
    removeFileList({ file }) {
      this.$refs.uploadRef?.removeFile(file);
    },
    handlePCSDialog(type, data) {
      this.showPCSDialogType = type;
      switch (type) {
        case 'unAvailableChannel':
          this.customPCSDialogBtnClick = this.helpSupport;
          break;
        case 'voucherNotSupported':
          // 入金方式不支援该优惠券弹窗点击
          this.customPCSDialogBtnClick = () => this.removeVoucher();
          this.customPCSDialogAnotherPaymentClick = () => {
            this.chooseAnotherPayment();
            this.sensorsClick('DEPOSIT_POPUP_COUPONUNUSABLE_CLICK', { button_name: 'Choose Another Payment Method' });
          };
          // 入金方式不支援该优惠券弹窗浏览
          this.sensorsClick('DEPOSIT_POPUP_COUPONUNUSABLE_VIEW');
          break;
        case 'overLimit':
          this.customPCSDialogBtnClick = () => {
            this.changeAmount(data.amountLimit);
            this.sensorsClick('DEPOSIT_POPUP_MAXDEPOSITUNMET_CLICK', { button_name: 'Change Amount' });
          };
          this.channelLimit = data.amountLimit + data.accountCurrency;
          this.customPCSDialogAnotherPaymentClick = () => {
            this.chooseAnotherPayment();
            this.sensorsClick('DEPOSIT_POPUP_MAXDEPOSITUNMET_CLICK', { button_name: 'Choose Another Payment Method' });
          };
          // 入金方式不满足最大额度弹窗浏览
          this.sensorsClick('DEPOSIT_POPUP_MAXDEPOSITUNMET_VIEW');
          break;
        case 'underLimit':
          // 入金方式不足最小额度弹窗点击
          this.customPCSDialogBtnClick = () => {
            this.changeAmount(data.amountLimit);
            this.sensorsClick('DEPOSIT_POPUP_MINDEPOSITUNMET_CLICK', { button_name: 'Change Amount' });
          };
          this.channelLimit = data.amountLimit + data.accountCurrency;
          this.customPCSDialogAnotherPaymentClick = () => {
            this.chooseAnotherPayment();
            this.sensorsClick('DEPOSIT_POPUP_MINDEPOSITUNMET_CLICK', { button_name: 'Choose Another Payment Method' });
          };
          // 入金方式不足最小额度弹窗浏览
          this.sensorsClick('DEPOSIT_POPUP_MINDEPOSITUNMET_VIEW');
          break;
        case 'advanceKYC':
          // 入金未完成进阶KYC弹窗点击
          this.customPCSDialogBtnClick = this.completedKYC;
          this.customPCSDialogAnotherPaymentClick = () => {
            this.chooseAnotherPayment();
            this.sensorsClick('DEPOSIT_POPUP_ADVANCEDKYCREQ_CLICK', { button_name: 'Choose Another Payment Method' });
          };
          // 入金未完成KYC弹窗浏览
          this.sensorsClick('DEPOSIT_POPUP_ADVANCEDKYCREQ_VIEW');
          break;
        case 'underReviewKYC':
          this.customPCSDialogBtnClick = this.chooseAnotherPayment;
          break;
        // case 'advanceKYC':
        case 'faceOfProofNew':
        case 'faceOfProofFail':
          this.customPCSDialogBtnClick = () => this.completedKYC;
          this.customPCSDialogAnotherPaymentClick = () => {
            this.chooseAnotherPayment();
          };
          break;
        case 'faceOfProofAudit':
          this.customPCSDialogBtnClick = this.chooseAnotherPayment();
          break;
        default:
          break;
      }
      this.showPCSDialog = true;
    },
    observerCallBack(width) {
      if (width < 1024) {
        this.showSteps = false;
      } else {
        this.showSteps = true;
      }
    },
    async handlePopstate(event) {
      console.log('event', event);
      if (this.currentStep == 1) {
        history.go(this.historyBackNum);
      } else if (this.currentStep == 2) {
        this.goBackStep1();
      } else if (this.currentStep == 3) {
        this.loading = true;
        new Promise((resolve, reject) => {
          this.goBackStep1();
          resolve();
        }).then(() => {
          this.submitStep1(true);
        });
      }
      if (this.showResult) {
        this.showResult = false;
      }
    },
    async checkUserStatus() {
      // if (!this.isVFSC || this.excludeReviewCountries.includes(this.country)) {
      //   // 非v1 v2
      //   return;
      // }
      // // v1 v2
      // await this.$store.dispatch('common/actionAccountAuditStatus');
      // await this.$store.dispatch('common/actionApiGetAllLastProof');
      // // Not open account
      // if (statusDeposit(this.accountAuditStatus) == 'init' || this.registerStep < 5) {
      //   this.depositRVisible = true;
      //   this.depositType = 'channel';
      //   return;
      // }
    },
    sensorsClick(event, params = {}) {
      // 入金方式不支援该优惠券弹窗浏览
      if (event === 'DEPOSIT_POPUP_COUPONUNUSABLE_VIEW') {
        sensorsHandler('DEPOSIT_POPUP_COUPONUNUSABLE_VIEW', {
          ...this.orderInfo,
          coupon_id: this.redemptionCode ? this.userCouponId : null,
          coupon_name: this.redemptionCode ? this.voucherApplied : null,
          coupon_amount: this.redemptionCode ? this.capAmount : null,
          coupon_type: this.redemptionCode ? this.couponType : null
        });
        return;
      }

      // 入金方式不支援该优惠券弹窗点击
      if (event === 'DEPOSIT_POPUP_COUPONUNUSABLE_CLICK') {
        sensorsHandler('DEPOSIT_POPUP_COUPONUNUSABLE_CLICK', {
          ...this.orderInfo,
          button_name: params.button_name,
          coupon_id: this.redemptionCode ? this.userCouponId : null,
          coupon_name: this.redemptionCode ? this.voucherApplied : null,
          coupon_amount: this.redemptionCode ? this.capAmount : null,
          coupon_type: this.redemptionCode ? this.couponType : null
        });
        return;
      }

      // 入金方式不足最小额度弹窗浏览
      if (event === 'DEPOSIT_POPUP_MINDEPOSITUNMET_VIEW') {
        sensorsHandler('DEPOSIT_POPUP_MINDEPOSITUNMET_VIEW', { ...this.orderInfo });
        return;
      }

      // 入金方式不足最小额度弹窗点击
      if (event === 'DEPOSIT_POPUP_MINDEPOSITUNMET_CLICK') {
        sensorsHandler('DEPOSIT_POPUP_MINDEPOSITUNMET_CLICK', { ...this.orderInfo, button_name: params.button_name });
        return;
      }

      // 入金方式不满足最大额度弹窗浏览
      if (event === 'DEPOSIT_POPUP_MAXDEPOSITUNMET_VIEW') {
        sensorsHandler('DEPOSIT_POPUP_MAXDEPOSITUNMET_VIEW', { ...this.orderInfo });
        return;
      }

      // 入金方式不满足最大额度弹窗点击
      if (event === 'DEPOSIT_POPUP_MAXDEPOSITUNMET_CLICK') {
        sensorsHandler('DEPOSIT_POPUP_MAXDEPOSITUNMET_CLICK', { ...this.orderInfo, button_name: params.button_name });
        return;
      }

      // 入金未完成KYC弹窗浏览
      if (event === 'DEPOSIT_POPUP_ADVANCEDKYCREQ_VIEW') {
        sensorsHandler('DEPOSIT_POPUP_ADVANCEDKYCREQ_VIEW');
        return;
      }

      // 入金未完成进阶KYC弹窗点击
      if (event === 'DEPOSIT_POPUP_ADVANCEDKYCREQ_CLICK') {
        console.log('this.orderInfo', this.orderInfo);
        sensorsHandler('DEPOSIT_POPUP_ADVANCEDKYCREQ_CLICK', { ...this.orderInfo, button_name: params.button_name });
        return;
      }

      // 入金Step2_条款弹窗确认点击
      if (event === 'DEPOSIT_STEP2_IBTPAGETERMSPOPUP_CONFIRM_CLICK') {
        sensorsHandler('DEPOSIT_STEP2_IBTPAGETERMSPOPUP_CONFIRM_CLICK', this.orderInfo);
        return;
      }

      // 入金Step2页跳转第三方
      if (event === 'DEPOSIT_STEP2PAGE_JUMP_THIRD_PARTY') {
        sensorsHandler('DEPOSIT_STEP2PAGE_JUMP_THIRD_PARTY', this.orderInfo);
        return;
      }

      if (event === 'DEPOSIT_STEP1PAGE_ACCOUNT_SELECT') {
        const data = {
          account_type: this.accountType,
          account_info: this.accountNumber
        };
        sensorsDepositStep1PageAccountSelect(data);
        return;
      }

      if (event === 'DEPOSIT_STEP1PAGE_AMOUNT_INPUT') {
        const data = {
          account_platform: this.accountPlatform,
          account_type: this.accountType,
          account_info: this.accountNumber,
          is_coupon: this.redemptionCode ? 1 : 0,
          error_alerts: this.amountErrMsg ?? null
        };
        sensorsDepositStep1PageAmountInput(data);
        return;
      }

      if (event === 'DEPOSIT_STEP1PAGE_VOUCHER_USE') {
        const data = {
          account_platform: this.accountPlatform,
          account_type: this.accountType,
          account_info: this.accountNumber,
          is_coupon: this.redemptionCode ? 1 : 0,
          coupon_id: this.redemptionCode ? this.userCouponId : null,
          coupon_name: this.redemptionCode ? this.voucherApplied : null,
          coupon_amount: this.redemptionCode ? this.capAmount : null,
          coupon_type: this.redemptionCode ? this.couponType : null
        };
        sensorsDepositStep1PageVoucherUse(data);
        return;
      }

      if (event === 'DEPOSIT_STEP1PAGE_CONTINUE_CLICK') {
        const data = {
          account_platform: this.accountPlatform,
          account_type: this.accountType,
          account_info: this.accountNumber,
          is_coupon: this.redemptionCode ? 1 : 0,
          coupon_id: this.redemptionCode ? this.userCouponId : null,
          coupon_name: this.redemptionCode ? this.voucherApplied : null,
          coupon_amount: this.redemptionCode ? this.capAmount : null,
          coupon_type: this.redemptionCode ? this.couponType : null,
          error_number: params.error_number || null
        };
        sensorsDepositStep1PageContinueClick(data);
      }
    },
    async launchWebSdk() {
      try {
        this.isShowSumsubDialog = true;
        const snsWebSdkInstance = snsWebSdk
          .init(this.sumsubAccessToken, () => this.getAccessToken())
          .withConf({
            lang: this.sumsubLang,
            theme: 'dark' | 'light'
          })
          .withOptions({ addViewportTag: false, adaptIframeHeight: true })
          .on('idCheck.onApplicantStatusChanged', resp => {
            if (resp.reviewStatus === 'completed') {
              if (resp.reviewResult.reviewAnswer === 'GREEN') {
                setTimeout(() => {
                  this.isShowSumsubDialog = false;
                  this.chooseAnotherPayment();
                  this.goBackStep1();
                }, 2500);
              }
              if (resp.reviewResult.reviewAnswer === 'RED' && resp.reviewResult.reviewRejectType !== 'RETRY') {
                setTimeout(() => {
                  this.isShowSumsubDialog = false;
                  this.chooseAnotherPayment();
                  this.goBackStep1();
                }, 2500);
              }
            } else {
              // this.handlePCSDialog('faceOfProofAudit');
              this.isShowSumsubDialog = false;
              this.chooseAnotherPayment();
              this.goBackStep1();
            }
          })
          .build();
        this.$nextTick(() => {
          snsWebSdkInstance.launch('#sumsub-websdk-container');
        });
      } catch (error) {}
    },
    async getAccessToken() {
      try {
        const res = await apiGetSumsubAccessToken();
        if (res.data.code === 0) {
          return res.data.data;
        } else {
          return '';
        }
      } catch (error) {
        console.log(error);
        return '';
      }
    }
  },
  computed: {
    eligibleCampaigns() {
      return this.$store.state.promotion.eligibleCampaigns;
    },
    campaignDepositBonusID() {
      return this.eligibleCampaigns.find(c => c.campaignType === 'DEPOSIT_BONUS_2').id;
    },
    pcsLang() {
      return I18N_PAYMENT_CENTER_MAP[this.lang] || 'en_US';
    },
    lang() {
      return this.$store.state.common.lang;
    },
    getAllowUploadFileTypes() {
      return this.allowUploadFileTypes;
    },
    getAcceptFile() {
      return this.allowUploadFileTypes?.map(type => `.${type}`).join(',');
    },
    getMaxFileNumber() {
      return this.maxFileNumber;
    },
    getMaxFileSize() {
      return this.maxFileSize;
    },
    country() {
      return parseInt(this.$store.state.common.countryCode);
    },
    accountAuditStatus() {
      return this.$store.state.common.accountAuditStatus;
    },
    ibtPoiAuditStatus() {
      return this.$store.state.common.ibtPoiAuditStatus;
    },
    ibtPoaAuditStatus() {
      return this.$store.state.common.ibtPoaAuditStatus;
    },
    registerStep() {
      return this.$store.state.common.registerStep * 1;
    },
    cssVars() {
      return {
        '--iframe-height': `${this.iframeHeight + 60}px`
      };
    },
    sumsubLang() {
      switch (this.lang) {
        case 'zh_CN':
          return 'zh';
        case 'zh_TW':
          return 'zh-tw';
        default:
          return I18N_PLATFORM_MAP[this.lang] || 'en';
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!store.state.payment.isUsePcs) {
      next(vm => {
        vm.$router.go(0);
      });
    } else {
      next();
    }
  },
  watch: {
    fileList(list) {
      const iframe = document.getElementById('pcs-iframe');
      iframe.contentWindow.postMessage(
        {
          status: 'uploadFile',
          data: list
        },
        '*'
      );
    },
    accountNumber() {
      this.sensorsClick('DEPOSIT_STEP1PAGE_ACCOUNT_SELECT');
    },
    amount(newVal) {
      // if (newVal == 0 || newVal === null) return;
      this.sensorsClick('DEPOSIT_STEP1PAGE_AMOUNT_INPUT');
    },
    redemptionCode() {
      this.sensorsClick('DEPOSIT_STEP1PAGE_VOUCHER_USE');
    }
  },
  mounted() {
    sensorsHandler('DEPOSIT_STEP1PAGE_VIEW');
    this.getCompaignData();
    window.addEventListener('message', this.receiveMessage, false);
    window.addEventListener('popstate', this.handlePopstate);

    // this.checkUserStatus();
  },
  beforeDestroy() {
    this.$refs.uploadRef.clearFileList();
    window.removeEventListener('message', this.receiveMessage);
    window.removeEventListener('popstate', this.handlePopstate);
  }
};
</script>

<style lang="scss" scoped>
// #depositPCS {
//   @include screen-mobile {
//     padding-top: 28px;
//   }
// }

// .step1 {
//   max-width: 1042px !important;
//   margin-left: auto;
//   margin-right: auto;
//   border-radius: 20px;
//   background-color: $white;
//   padding-top: 100px;
//   @include screen-tablet {
//     padding: 0px;
//   }
// }

.step2 {
  padding-top: 40px;
  @include screen-tablet {
    padding-top: 20px;
  }
}

#pcs-iframe {
  height: calc(100dvh - 214px) !important;
  border: none;
}

@media (min-width: 768px) {
  #pcs-iframe {
    height: var(--iframe-height) !important;
  }
}

.deposit-title {
  margin-top: 40px;
}
</style>
